export default ([lng, lat]) => ({ lat, lng });
